import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  recordedChapterData: [],
  totalrecordedChapter: 0,
  isOpenModal: false,
}

export const recordedChapterSlice = createSlice({
  name: "recordedChapter",
  initialState,
  reducers: {
    setrecordedChapterData(state, { payload }) {
      state.recordedChapterData = payload.result
      state.totalrecordedChapter = payload.count
    },
    updaterecordedChapterData(state, { payload }) {
      const objIndex = state.recordedChapterData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.recordedChapterData[objIndex] = payload
      }
    },
    deleterecordedChapterData(state, { payload }) {
      const objIndex = state.recordedChapterData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.recordedChapterData.splice(objIndex, 1)
      }
    },
    pushrecordedChapterData(state, { payload }) {
      state.recordedChapterData.push(payload)
      state.totalrecordedChapter += 1
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setrecordedChapterData, updaterecordedChapterData, deleterecordedChapterData, pushrecordedChapterData, isOpenModal,
  ModalToggle } = recordedChapterSlice.actions;

export default recordedChapterSlice.reducer;

export function getrecordedChapter(limit, offset, id) {
  return async function getrecordedChapterThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getrecordedChapter(limit, offset, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setrecordedChapterData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addrecordedChapter(data) {
  return async function addrecordedChapterThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addrecordedChapter(data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushrecordedChapterData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updaterecordedChapter(id, title) {
  return async function updaterecordedChapterThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updaterecordedChapter(id, title).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updaterecordedChapterData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function statusDeleterecordedChapter(id) {
  return async function statuseleterecordedChapterThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdaterecordedChapter(id).then(
        (response) => {
          dispatch(deleterecordedChapterData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



